require('./core');
import 'bootstrap5';
require('./voicer');

import 'bootstrap5/scss/bootstrap.scss';
import '../css/voicer.css';
